import { useNavigate } from "react-router-dom";

interface AccessDeniedProps {
  title?: string;
  message?: string;
}

export default function AccessDenied({
  title = "لا تملك صلاحية الوصول إلى هذا القسم",
  message = "هذا القسم غير ممنوح لحسابك من صاحب المحل. تواصل مع صاحب المحل إذا كنت تحتاج إلى صلاحية الوصول.",
}: AccessDeniedProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center bg-background-50 rounded-card border border-background-200 p-8 animate-fade-slide-up">
        <div className="mx-auto w-20 h-20 rounded-full bg-red-50 flex items-center justify-center">
          <i className="ri-lock-2-line text-4xl text-red-500"></i>
        </div>
        <h2 className="mt-5 text-lg font-bold text-foreground-900 leading-relaxed">{title}</h2>
        <p className="mt-2.5 text-sm text-foreground-500 leading-relaxed">{message}</p>

        <div className="mt-6 flex flex-col sm:flex-row gap-2.5">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="flex-1 h-12 rounded-btn border border-background-300 text-foreground-700 text-sm font-bold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            رجوع
          </button>
          <button
            type="button"
            onClick={() => navigate("/orders")}
            className="flex-1 h-12 rounded-btn bg-primary-500 text-white text-sm font-bold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            الذهاب إلى الطلبات
          </button>
        </div>
      </div>
    </div>
  );
}